import React, { useEffect, useState } from "react";
import { AppRemixIcon } from "@/layout/AppComponents";
import axios from "axios";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import ReactDOMServer from "react-dom/server";
import colors from "../../../../../../../constants/colors";
import ErrorHandler from "../../../../../../components/error/ErrorHandler";
import { axiosPath } from "../../../../../../../routing/helpers/router";
import AppSpinner from "../../../../../../components/AppSpinner";
import Translator from "../../../../../../components/helpers/Translator";

const MaintenanceCheckIcon = (props) => {
  const { isMaintenanceCheck, plantObligationID } = props;
  const dispatch = useDispatch();
  const { moduleBridgeHex, plantHex } = useParams();
  const [maintenanceCheck, setMaintenanceCheck] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (maintenanceCheck === undefined) setMaintenanceCheck(isMaintenanceCheck);
  }, [isMaintenanceCheck]);

  // > CHANGE FAVOURITE
  const changeMaintenanceChecked = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        axiosPath(
          "api_r_user_module_legalCompliance_evaluation_setMaintenanceChecked"
        ),
        { moduleBridgeHex, plantHex, plantObligationID }
      );
      setIsLoading(false);
      setMaintenanceCheck(response.data);
    } catch (err) {
      setIsLoading(false);
      dispatch(ErrorHandler(err, history));
    }
  };
  // < CHANGE FAVOURITE

  if (isLoading) {
    return (
      <AppSpinner>
        <AppRemixIcon icon="loader-4" color={colors.primary} />
      </AppSpinner>
    );
  }

  return (
    <AppRemixIcon
      icon="hammer"
      title={ReactDOMServer.renderToString(
        <Translator file="module-legalCompliance" name="maintenance" />
      )}
      color={maintenanceCheck ? colors.success : colors.grey300}
      className="pointer"
      filled={maintenanceCheck}
      onClick={() => changeMaintenanceChecked()}
    />
  );
};
export default MaintenanceCheckIcon;
